// import vInput from '@/ui/controls/vInput'
import vAutocomplete from '@/ui/controls/Autocomplete'
import ColorSelect from '@/ui/controls/ColorSelect'

import {
  ShowDashboardActions,
  ShowBills,
  ShowRegisteredUsers,
  ShowGoldShopStatistics,
  ShowOrders
} from '@/mixins/displayRules'
import profile from '@/mixins/profile'

import LatestOrders from './LatestOrders'
import DepositBalance from './DepositBalance'
import SummaryWidget from './SummaryWidget'
import ChartWidget from './ChartWidget'
import DashboardActions from './DashboardActions'
import RegisteredUsers from './RegisteredUsers'

export const settingsTypes = {
  input: 'input',
  checkbox: 'checkbox',
  radio: 'radio',
  select: 'select',
  multiSelect: 'multiSelect',
  color: 'color',
  image: 'image'
}

export const statWidgetDataSource = {
  COMMISSIONS: 'COMMISSIONS',
  GOLDSHOP: 'GOLDSHOP',
  SALES: 'SALES',
  USERS: 'USERS'
}

export default {
  mixins: [ShowDashboardActions, profile, ShowBills, ShowRegisteredUsers, ShowGoldShopStatistics, ShowOrders],

  computed: {
    summaryWidgetSettings () {
      if (this.ShowGoldShopStatistics) {
        return [
          { value: 'COMMISSIONS', text: this.$i18n.t('widgets.SummaryWidget.source.commissions') },
          { value: 'GOLDSHOP', text: this.$i18n.t('widgets.SummaryWidget.source.goldShopEarnings') },
          { value: 'SALES', text: this.$i18n.t('widgets.SummaryWidget.source.statSales') },
          { value: 'USERS', text: this.$i18n.t('widgets.SummaryWidget.source.referralStatistics') }
        ]
      }

      return [
        { value: 'COMMISSIONS', text: this.$i18n.t('widgets.SummaryWidget.source.commissions') },
        { value: 'SALES', text: this.$i18n.t('widgets.SummaryWidget.source.statSales') },
        { value: 'USERS', text: this.$i18n.t('widgets.SummaryWidget.source.referralStatistics') }
      ]
    },

    registeredWidgets () {
      return {
        LatestOrders: {
          name: this.$i18n.t('widgets.LatestOrders.title'),
          description: this.$i18n.t('widgets.LatestOrders.description'),
          component: LatestOrders,
          optional: false,
          unique: false,
          show: true,
          editable: true,
          disabled: false,
          hide: !this.ShowOrders,
          settings: {
            size: {
              component: vAutocomplete,
              props: {
                placeholder: this.$i18n.t('widgets.LatestOrders.size.label'),
                items: [3, 5, 7, 10, 15],
                notEmpty: true
              },
              default: 5
            }
          }
        },

        DepositBalance: {
          name: this.profile.prepayment ? this.$i18n.t('widgets.DepositBalance.title') : this.$t('widgets.DepositBalance.titleInvoices'),
          description: this.profile.prepayment ? this.$i18n.t('widgets.DepositBalance.description') : this.$t('widgets.DepositBalance.descriptionInvoices'),
          component: DepositBalance,
          optional: false,
          unique: false,
          hide: !this.ShowBills
        },

        SummaryWidget: {
          name: this.$i18n.t('widgets.SummaryWidget.title'),
          description: this.$i18n.t('widgets.SummaryWidget.description'),
          component: SummaryWidget,
          optional: false,
          unique: false,
          editable: true,
          settings: {
            source: {
              component: vAutocomplete,
              props: {
                items: this.summaryWidgetSettings,
                placeholder: this.$i18n.t('widgets.SummaryWidget.source.title'),
                valueField: 'value',
                itemText: 'text',
                notEmpty: true
              },
              default: 'COMMISSIONS'
            },

            color: {
              component: ColorSelect,
              props: {
                values: ['#0084F8', '#6C78E6', '#B9AE15'],
                label: this.$i18n.t('widgets.SummaryWidget.color.label')
              },
              default: '#0084F8'
            }
          }
        },

        ChartWidget: {
          name: this.$i18n.t('widgets.ChartStat.title'),
          description: this.$i18n.t('widgets.ChartStat.description'),
          component: ChartWidget,
          optional: false,
          unique: false,
          settings: {
            source: {
              component: vAutocomplete,
              props: {
                items: [{
                  value: 'COMMISSION',
                  text: this.$i18n.t('widgets.SummaryWidget.source.commissions')
                }],
                placeholder: this.$i18n.t('widgets.SummaryWidget.source.title'),
                valueField: 'value',
                itemText: 'text',
                notEmpty: true
              },
              default: 'COMMISSION'
            }
          },
          hide: !this.ShowOrders
        },

        DashboardActions: {
          name: this.$i18n.t('widgets.DashboardActions.title'),
          description: this.$i18n.t('widgets.DashboardActions.description'),
          component: DashboardActions,
          optional: false,
          unique: false,
          hide: !this.ShowDashboardActions
          // settings: {}
        },

        RegisteredUsers: {
          name: this.$i18n.t('widgets.RegisteredUsers.titleShort'),
          description: this.$i18n.t('widgets.RegisteredUsers.description'),
          component: RegisteredUsers,
          optional: true,
          unique: false,
          // disabled: true,
          hide: !this.ShowRegisteredUsers
          // settings: {
          //   // size: {
          //   //   label: 'Количество записей',
          //   //   type: settingsTypes.select,
          //   //   default: 5,
          //   //   options: [3, 5, 10, 12, 15]
          //   // }
          // }
        }
      }
    },
    computedRegisteredWidgets () {
      const out = {}
      Object.keys(this.registeredWidgets).forEach(key => {
        const res = this.registeredWidgets[key]
        res.key = key
        if (res.settings) {
          for (const settingsKey of Object.keys(res.settings)) {
            res.settings[settingsKey].settingsKey = settingsKey
          }
        }
        out[key] = res
      })

      return out
    }
  }
}
